import React, { useEffect, useState } from 'react';
import { CommonHeader, Loader, ErrorSuccessModal } from '../../../components/commons';
import { useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import { RootState } from '../../../redux/rootReducers';
import {
    resetInvoiceStatusCode,
    resetInvoicingError,
    resetInvoicingSuccess,
    resetBulkUploadData
} from '../../../redux/invoicing';
import { DownloadIcon } from "../../../components/Icon";
import { resetSession } from '../../../redux/auth';
import FileSaver from 'file-saver';
import DraggableUpload from '../../../components/commons/Upload/DraggableUpload'
import toast, { Toaster } from 'react-hot-toast';

import { invoiceBulkUploadAction } from '../../../redux/invoicing/actions'

const blobBaseUrl = process.env.REACT_APP_BLOB_BASE_URL;
const blobToken = process.env.REACT_APP_BLOB_TOEKN;


interface Props {
    individualColumnList: any | null;
    token: string | null;
    invoiceBulkUploadActionDispatch: Function;
    bulkUploadData: any | null;
    fetching: boolean;
    success: number | null;
    error: string | null;
    statusCode: number | null;
    dispatchResetSession: () => void;
    dispatchResetInvoiceStatusCode: () => void;
    dispatchResetInvoicingError: Function;
    dispatchResetInvoicingSuccess: () => void;
    dispatchResetBulkUploadData: Function;
}

const BulkUpload = ({
    individualColumnList,
    invoiceBulkUploadActionDispatch,
    token,
    bulkUploadData,
    success,
    error,
    statusCode,
    fetching,
    dispatchResetSession,
    dispatchResetInvoicingError,
    dispatchResetBulkUploadData,
    dispatchResetInvoicingSuccess
}: Props) => {
    const search = useLocation().search;
    const type = new URLSearchParams(search).get('type') || '';
    const url = window.location.pathname.split('/')
    const client_code = Number(url[url.length - 1])

    const [fileData, setFileData] = useState<any>('')
    const [fileNames, setFileNames] = useState([])
    
    const finalType= type==='expenses'
                            ? 'Purchase/Expense Entries' 
                            :  type==='revenue'
                                ? 'Sales/Receipts Entries' 
                                : 'Other Entries'


    useEffect(() => {
        dispatchResetInvoicingError();
        dispatchResetInvoicingSuccess();
        dispatchResetBulkUploadData();
    }, [])



    const downloadTemplate = () => {

        let headList: string[] = []

        individualColumnList
            && individualColumnList[type].map((item: any) => {
                headList.push(item['name'])
            }) 
        let csvData = headList.toString();
        var blob = new Blob([csvData], {
            type: "text/csv;charset=utf-8;"
        });

        FileSaver.saveAs(blob, 'template.csv');
    }

    const handleUpload = (file: any) => {
        setFileData(file)
    }
    const startBulkProcess = () => {
        const params = {
            client_code,
            type,
            fileData,
            token
        }
        invoiceBulkUploadActionDispatch(params)
    }

    const handleErrorModal = () => {

  
        if (bulkUploadData && bulkUploadData?.success === 0 || success === 0) {
            if (bulkUploadData && bulkUploadData?.status_code === 401 || statusCode === 401) {
                return (
                    <ErrorSuccessModal
                        type="error"
                        isOpen={!!error}
                        title="Error"
                        message={error}
                        buttonText="Logout"
                        onPress={() => {
                            dispatchResetSession();
                            dispatchResetInvoicingError();
                        }}
                        statusCode={statusCode}
                    />
                )
            } else if (bulkUploadData && bulkUploadData?.status_code === 204
                || bulkUploadData && bulkUploadData?.status_code === 500
                || error) {
                return (
                    <ErrorSuccessModal
                        type="error"
                        isOpen={!bulkUploadData?.success}
                        title="Error"
                        message={bulkUploadData?.message || "something went wrong!"}
                        buttonText="OK"
                        onPress={
                            () => {
                                dispatchResetBulkUploadData()
                                setFileNames([])
                                
                            }
                        }
                    />
                )
            }
        }

        if (bulkUploadData?.success === 1 && bulkUploadData && bulkUploadData?.message) {

            if (bulkUploadData && bulkUploadData?.error_rows_count === 0) {
                return (<ErrorSuccessModal
                    type="success"
                    isOpen={bulkUploadData?.success === 1}
                    title="Success"
                    message={bulkUploadData?.message || "Document Uploaded Successfully!"}
                    buttonText="OK"
                    onPress={() => {
                        dispatchResetBulkUploadData()
                        setFileNames([])
                    }}
                    statusCode={bulkUploadData?.status_code || statusCode}
                />)
            } else {
                toast.success(bulkUploadData?.message);
            }
        }
        return false;
    }
  
    const renderReUpload = () => {
        const {
            total_rows_count,
            inserted_rows_count,
            error_rows_count,
            error_file
        } = bulkUploadData
        return <div className="dropzone drop-area text-center" style={{ cursor: 'default' }}>
            <h4>File uploaded successfully! However, there were a few errors in the file.
                Please download the file and fix the errors and re-upload the file. Thanks.</h4>
            <hr />
            <h3 className="text-info">Total Count: {total_rows_count}</h3>
            <h3 className="text-success">Successful entry: {inserted_rows_count}</h3>
            <h3 className="text-danger">Number of Errors: {error_rows_count}</h3>
            <hr />
            <a href={blobBaseUrl + error_file + '?' + blobToken} className="btn btn-outline-info">Download Error CSV</a>

        </div>
    }
    const handleReUpload = () => {
        dispatchResetBulkUploadData()
        setFileNames([])
        setFileData('')
    }

    return (
        <div className="row">

            <div className="col-md-8 mb-3">
                <CommonHeader goBack title={`Bulk Upload - ${ finalType }`} />
            </div>
            <div className='col-12'>
                <div className=" card p-3">
                    <p className="text-right">
                        <button className='btn btn-outline-info' onClick={downloadTemplate}>
                            <DownloadIcon color="#17a2b8" /> Download Blank Template
                        </button>
                    </p>
                
                    {bulkUploadData && bulkUploadData.error_rows_count && bulkUploadData.error_rows_count > 0 ?
                        renderReUpload()
                        : <DraggableUpload
                            handleUpload={handleUpload}
                            setFileNames={setFileNames}
                            fileNames={fileNames}

                        />
                    }
                    {bulkUploadData && bulkUploadData.error_rows_count > 0
                        ?
                        <div className="mt-3 d-flex">
                            <button
                                className='ml-3 btn btn-lg btn-primary w-50 m-auto'
                                onClick={() => handleReUpload()}
                            >
                                Proceed to Re-Upload
                            </button>
                        </div>
                        :
                        <div className="mt-3 d-flex">
                            <button
                                className="btn btn-primary btn-lg w-50 m-auto"
                                onClick={startBulkProcess}
                                disabled={!fileData || !fileNames.length || fetching ? true : false}
                            >
                                Proceed
                            </button>
                        </div>}
                </div>
                {fetching ? <Loader /> : null}
                {handleErrorModal()}
                <Toaster />
            </div>
        </div>
    )
}

const mapStateToProps = (state: RootState) => ({
    individualColumnList: state.invoicing.individualColumnList,
    bulkUploadData: state.invoicing.bulkUploadData,
    token: state.auth.token,
    fetching: state.invoicing.fetching,
    success: state.invoicing.success,
    error: state.invoicing.error,
    statusCode: state.invoicing.statusCode,
})

const mapDispatchToProps = (dispatch: any) => ({
    dispatchResetBulkUploadData: () => dispatch(resetBulkUploadData()),
    dispatchResetSession: () => dispatch(resetSession()),
    dispatchResetInvoiceStatusCode: () => dispatch(resetInvoiceStatusCode()),
    dispatchResetInvoicingError: () => dispatch(resetInvoicingError()),
    dispatchResetInvoicingSuccess: () => dispatch(resetInvoicingSuccess()),
    invoiceBulkUploadActionDispatch: (params: any) => dispatch(invoiceBulkUploadAction(params))
})

export default connect(mapStateToProps, mapDispatchToProps)(BulkUpload)